export interface Presenter<EntityInput, Response = any> {
  toResponse(entity: EntityInput): Response;
}
